import { createTheme } from '@mui/material/styles';
const color =
	'-webkit-linear-gradient(left bottom, #ffe000, #f9b097, #e7c7db, #87beaf, #6998d0, #7265ad)';
const secondaryColor = '#7265AD';
const primaryColor = '#ffe000';
const white = '#fff';
const baseTheme = createTheme({
	typography: {
		fontFamily: '"Outfit", Sans-serif'
	},
	palette: {
		type: 'light',
		background: {
			default: white,
			darker: '#a5a291'
		},
		disabled: {
			light: '#e5e5e5',
			main: '#f9f9f9'
		},
		success: {
			main: '#58a758'
		},
		error: {
			main: '#FF0000'
		},
		warning: {
			main: '#cbcb04'
		},
		common: {
			white,
			black: '#000000',
			gray: '#7D7D7D'
		},
		primary: {
			main: primaryColor
		},
		secondary: {
			main: secondaryColor
		}
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				body: {
					background: color,
					backgroundAttachment: 'fixed'
				}
			}
		},
		MuiButton: {
			styleOverrides: {
				root: {
					backgroundColor: secondaryColor,
					color: white,
					border: `3px solid ${secondaryColor}`,
					'&:hover': {
						backgroundColor: white,
						color: secondaryColor,
						border: `3px solid ${secondaryColor}`
					},
					borderRadius: 10,
					fontWeight: 'bold'
				}
			}
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						backgroundColor: white,
						borderRadius: 0,
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: white,
							borderWidth: '1px'
						},
						'&.Mui-focused': {
							'& .MuiOutlinedInput-notchedOutline': {
								borderColor: white,
								borderWidth: '1px'
							}
						},
						'&:hover:not(.Mui-focused)': {
							'& .MuiOutlinedInput-notchedOutline': {
								borderColor: white
							}
						}
					},
					'& .MuiInputLabel-outlined': {
						color: '#7D7D7D',
						'&.Mui-focused': {
							color: '#7D7D7D'
						}
					}
				}
			}
		},
		MuiDialog: {
			styleOverrides: {
				root: {
					'& .MuiPaper-root': {
						borderRadius: '16px',
						backgroundColor: primaryColor,
						textAlign: 'center',
						padding: '15px 35px'
					}
				}
			}
		}
	}
});

export default baseTheme;
